<script lang="ts">
  // The day picker sitting above both Overview tabs (Pulse, By site): which
  // day am I looking at, and step back/forward one day. Deliberately not a
  // date input — the question this answers is almost always "what about
  // yesterday?", and a chevron answers it in one tap on a phone, where a
  // native date picker is a full-screen modal.
  //
  // Forward is capped at today: GET /api/hr/overview clamps a future date
  // server-side anyway, so a live-looking "tomorrow" would just be today's
  // numbers under the wrong label.
  import { ChevronLeft, ChevronRight } from 'lucide-svelte';
  import { fmtDayLabel, shiftISO, todayISO } from '$lib/utils/appDate';

  const { date, onChange }: { date: string; onChange: (date: string) => void } = $props();

  const today = $derived(todayISO());
  const isToday = $derived(date === today);
</script>

<div class="mb-4 flex items-center gap-2">
  <button
    type="button"
    class="btn-secondary h-11 w-11 shrink-0 !px-0"
    aria-label="Previous day"
    onclick={() => onChange(shiftISO(date, -1))}
  >
    <ChevronLeft class="h-5 w-5" aria-hidden="true" />
  </button>

  <div class="min-w-0 flex-1 text-center">
    <p class="truncate text-[15px] font-semibold text-navy" data-testid="overview-date-label">
      {isToday ? 'Today' : fmtDayLabel(date)}
    </p>
    <p class="tym-section-sub truncate">{isToday ? fmtDayLabel(date) : 'Past day — live counts hidden'}</p>
  </div>

  <button
    type="button"
    class="btn-secondary h-11 w-11 shrink-0 !px-0"
    aria-label="Next day"
    disabled={isToday}
    onclick={() => onChange(shiftISO(date, 1))}
  >
    <ChevronRight class="h-5 w-5" aria-hidden="true" />
  </button>

  {#if !isToday}
    <button type="button" class="btn-secondary h-11 shrink-0" onclick={() => onChange(today)}>Today</button>
  {/if}
</div>
